export default __webpack_public_path__ + "public/assets/images/3006badeb5ba740330120a13a7ebcc60.png";